"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactInformation = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("@reach/router");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const constants_1 = require("../../../constants");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
const UpdateAccountInformation_1 = require("../updateAccountInformation/UpdateAccountInformation");
const CustomerAccount_1 = require("../../CustomerAccount");
const ContactInformation = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const { localizePath } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const currentUser = customerAccountContext.currentUser;
    const navigateToCustomerAccountInformation = () => {
        (0, router_1.navigate)(localizePath(CustomerAccount_1.CUSTOMER_ACCOUNT_PATH + UpdateAccountInformation_1.UPDATE_ACCOUNT_INFORMATION_PATH));
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-contact-information" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-myaccount-contact-information-title" }, t("customerAccount.myAccount.contactInformation.title")),
        react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-contact-information-header" },
            react_1.default.createElement("p", { className: "boutik-customer-account-myaccount-contact-information-name" }, `${currentUser === null || currentUser === void 0 ? void 0 : currentUser.firstname} ${currentUser === null || currentUser === void 0 ? void 0 : currentUser.lastname}`),
            react_1.default.createElement("p", { className: "boutik-customer-account-myaccount-contact-information-email" }, currentUser === null || currentUser === void 0 ? void 0 : currentUser.email)),
        react_1.default.createElement("div", { className: "boutik-customer-account-myaccount-contact-information-link-container" },
            react_1.default.createElement("a", { className: "boutik-customer-account-myaccount-contact-information-edit-link", onClick: navigateToCustomerAccountInformation }, t("global.button.edit")))));
};
exports.ContactInformation = ContactInformation;
//# sourceMappingURL=ContactInformation.js.map